import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "gfu-grid__cell gfu-1of1" }
const _hoisted_2 = { class: "_flex _fd-c _gap-3" }
const _hoisted_3 = {
  key: 0,
  class: "_flex _fd-c",
  "data-qa": "blog-notifications"
}
const _hoisted_4 = {
  key: 2,
  class: "_flex _fd-c _gap-3",
  "data-qa": "your-project-activity"
}
const _hoisted_5 = ["data-qa"]
const _hoisted_6 = { class: "gfu-bt gfu-bt--caption _tc--light _mt-0 _ttu" }
const _hoisted_7 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_title = _resolveComponent("base-title")
  const _component_option_field = _resolveComponent("option-field")
  const _component_adfound_notification_management_settings = _resolveComponent("adfound-notification-management-settings")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_box, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_base_title, { as: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.SubscriptionManagement.CreatorNotificationHeader), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          ($options.showBlogNotificationSettings)
            ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
                _createVNode(_component_base_title, {
                  as: "h3",
                  uppercase: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Resources.SubscriptionManagement.BlogNotificationsSubsectionHeader), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.blogNotificationOptions, (option) => {
                  return (_openBlock(), _createBlock(_component_option_field, {
                    key: option.model,
                    modelValue: _ctx.model.blogNotifications[option.model],
                    "onUpdate:modelValue": [$event => ((_ctx.model.blogNotifications[option.model]) = $event), $event => ($options.onBlogNotificationPreferenceChange(option))],
                    "first-column-width": 8,
                    options: $setup.basePreferenceOptions,
                    "display-name": option.displayName,
                    name: `model.blogNotifications.${option.model}`,
                    layout: "columns",
                    description: option.description,
                    "data-qa": `blog-notifications:${option.model}`
                  }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options", "display-name", "name", "description", "data-qa"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          ($options.showAdfoundNotificationSettings)
            ? (_openBlock(), _createBlock(_component_adfound_notification_management_settings, _mergeProps({ key: 1 }, $options.adfoundNotificationProps, { onAdfoundNotificationPreferenceChange: $options.handleEmit }), null, 16 /* FULL_PROPS */, ["onAdfoundNotificationPreferenceChange"]))
            : _createCommentVNode("v-if", true),
          ($props.creatorSubscriptions.length)
            ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
                _createVNode(_component_base_title, {
                  as: "h3",
                  uppercase: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Resources.SubscriptionManagement.CreatorProjectActivitySubsectionHeader), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.creatorSubscriptions, (creator) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: creator.creatorID,
                    "data-qa": `creator-digest:${creator.creatorID}`
                  }, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.Resources.SubscriptionManagement.CreatorNotificationsSectionHeader), 1 /* TEXT */),
                    _createElementVNode("a", {
                      class: "gfu-subscription-management-settings__title",
                      href: creator.creatorUrl,
                      "data-qa": "creator-name"
                    }, _toDisplayString(creator.creatorName), 9 /* TEXT, PROPS */, _hoisted_7),
                    _createVNode(_component_option_field, {
                      modelValue: _ctx.model.creatorDigests[creator.creatorID],
                      "onUpdate:modelValue": [$event => ((_ctx.model.creatorDigests[creator.creatorID]) = $event), $event => ($options.onCreatorDigestPreferenceChange(creator.creatorID))],
                      "first-column-width": 8,
                      options: $setup.notificationPreferenceOptions,
                      "display-name": _ctx.Resources.SubscriptionManagement.CreatorDigestFieldLabel,
                      name: `model.creatorDigests.${creator.creatorID}`,
                      layout: "columns",
                      description: _ctx.Resources.SubscriptionManagement.CreatorDigestFieldDescription,
                      "data-qa": "creator-notifications:CreatorDigest"
                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options", "display-name", "name", "description"])
                  ], 8 /* PROPS */, _hoisted_5))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}